<div class="section-content content-max-width">
    <h2 class="heading-navy">
        Congratulations to the winners of Zip’s gift card promotions.
    </h2>
    <p>The winners listed <a
            href="https://assets.ctfassets.net/na6i9tntz090/7LScIfQZgAGPQMk0LnQyiM/e876cd15ae56b3b84833adee39ab7973/Woolworths_Unclaimed_prize_Winner_Announcement_.pdf"
            target="_blank">here</a> have won 1 of 25 $100 Woolworths gift cards, simply by purchasing a gift card with
        Zip between 12/12/2019 to 8/1/2020.</p>
    <p>The winners listed <a
            href="https://assets.ctfassets.net/1u65qlkmktuw/14oz3Xn1uD3f5F5yfgGxE8/d2ce4e33695302f571f399f2dd7facf3/Hoyts_unclaimed_prize_winner_announcement_.pdf"
            target="_blank">here</a> have won 1 of 25 $100 HOYTS gift cards, simply by purchasing a HOYTS gift card with
        Zip between 17/12/2019 to 13/1/2020.
    </p>
</div>
